/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getPharmacists } from 'app/entities/pharmacist/pharmacist.reducer';
import { getEntities as getDiaglabAssistants } from 'app/entities/diaglab-assistant/diaglab-assistant.reducer';
import { getEntities as getHospitalAssistants } from 'app/entities/hospital-assistant/hospital-assistant.reducer';
import { createEntity, getEntity, reset, updateEntity } from './person-name.reducer';

export const PersonNameUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const pharmacists = useAppSelector(state => state.pharmacist.entities);
  const diaglabAssistants = useAppSelector(state => state.diaglabAssistant.entities);
  const hospitalAssistants = useAppSelector(state => state.hospitalAssistant.entities);
  const personNameEntity = useAppSelector(state => state.personName.entity);
  const loading = useAppSelector(state => state.personName.loading);
  const updating = useAppSelector(state => state.personName.updating);
  const updateSuccess = useAppSelector(state => state.personName.updateSuccess);

  const handleClose = () => {
    navigate(`/person-name${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getDoctors({}));
    dispatch(getPharmacists({}));
    dispatch(getDiaglabAssistants({}));
    dispatch(getHospitalAssistants({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.totalReading !== undefined && typeof values.totalReading !== 'number') {
      values.totalReading = Number(values.totalReading);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...personNameEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      doctor: doctors.find(it => it.id.toString() === values.doctor?.toString()),
      pharmacist: pharmacists.find(it => it.id.toString() === values.pharmacist?.toString()),
      diaglabAssistant: diaglabAssistants.find(it => it.id.toString() === values.diaglabAssistant?.toString()),
      hospitalAssistant: hospitalAssistants.find(it => it.id.toString() === values.hospitalAssistant?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...personNameEntity,
          created: convertDateTimeFromServer(personNameEntity.created),
          patient: personNameEntity?.patient?.id,
          doctor: personNameEntity?.doctor?.id,
          pharmacist: personNameEntity?.pharmacist?.id,
          diaglabAssistant: personNameEntity?.diaglabAssistant?.id,
          hospitalAssistant: personNameEntity?.hospitalAssistant?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.personName.home.createOrEditLabel" data-cy="PersonNameCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.personName.home.createOrEditLabel">Create or edit a PersonName</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="person-name-id"
                  label={translate('tinyMedicRestApp.personName.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.preferred')}
                id="person-name-preferred"
                name="preferred"
                data-cy="preferred"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.givenName')}
                id="person-name-givenName"
                name="givenName"
                data-cy="givenName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.prefix')}
                id="person-name-prefix"
                name="prefix"
                data-cy="prefix"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.middleName')}
                id="person-name-middleName"
                name="middleName"
                data-cy="middleName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.familyNamePrefix')}
                id="person-name-familyNamePrefix"
                name="familyNamePrefix"
                data-cy="familyNamePrefix"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.familyName')}
                id="person-name-familyName"
                name="familyName"
                data-cy="familyName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.familyNameSufix')}
                id="person-name-familyNameSufix"
                name="familyNameSufix"
                data-cy="familyNameSufix"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.familyName2')}
                id="person-name-familyName2"
                name="familyName2"
                data-cy="familyName2"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.active')}
                id="person-name-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.created')}
                id="person-name-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.microSec')}
                id="person-name-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.timestampentry')}
                id="person-name-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.totalReading')}
                id="person-name-totalReading"
                name="totalReading"
                data-cy="totalReading"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.lastupdated')}
                id="person-name-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.personName.cursor')}
                id="person-name-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="person-name-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.personName.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="person-name-doctor"
                name="doctor"
                data-cy="doctor"
                label={translate('tinyMedicRestApp.personName.doctor')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="person-name-pharmacist"
                name="pharmacist"
                data-cy="pharmacist"
                label={translate('tinyMedicRestApp.personName.pharmacist')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacists
                  ? pharmacists.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="person-name-diaglabAssistant"
                name="diaglabAssistant"
                data-cy="diaglabAssistant"
                label={translate('tinyMedicRestApp.personName.diaglabAssistant')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabAssistants
                  ? diaglabAssistants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="person-name-hospitalAssistant"
                name="hospitalAssistant"
                data-cy="hospitalAssistant"
                label={translate('tinyMedicRestApp.personName.hospitalAssistant')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalAssistants
                  ? hospitalAssistants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/person-name" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PersonNameUpdate;
